<zbp-zbchart-report-table
  reportLabel="Benchmark Standards Over Time Table"
  [leftHeaderText]="'Unit'"
  [rightHeaderText]="'Averages'"
  [zbChart]="zbChart"
  [isPrinting]="false"
  [showProgressReportsHelp]="false"
  [useFrontEndPagination]="true"
/>
